if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Screen Protection (SP) Initialization
        this.initScreenProtection();
      }

      initScreenProtection() {
        this.spBlock = document.getElementById(`ScreenProtection-${this.dataset.sectionId}`);
        if (!this.spBlock) return;

        this.spInput = this.spBlock.querySelector('input[name="sp_variant_id"]');
        this.spIsAddedInput = this.spBlock.querySelector('input[id^="sp_is_added"]');
        this.priceDisplay = this.spBlock.querySelector('.sp-price-display');

        // Initial price setup
        this.updateSPPrice();

        // Listen for Add/Remove clicks within the block
        this.spBlock.addEventListener('click', (e) => {
          const btn = e.target.closest('.sp-toggle-btn');
          if (!btn) return;

          const isAdding = btn.classList.contains('sp-add-btn');

          this.spBlock.querySelector('.sp-add-btn').classList.toggle('hidden', isAdding);
          this.spBlock.querySelector('.sp-remove-btn').classList.toggle('hidden', !isAdding);
          if (this.spIsAddedInput) this.spIsAddedInput.value = isAdding ? 'true' : 'false';
        });

        // Sync with variant changes for price calculation
        const variantPicker = document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"]`);
        if (variantPicker) {
          variantPicker.addEventListener('change', () => {
            setTimeout(() => {
              if (variantPicker.currentVariant) {
                this.spBlock.dataset.productPrice = variantPicker.currentVariant.price / 100;
                this.updateSPPrice();
              }
            }, 50);
          });
        }
      }

      updateSPPrice() {
        if (!this.spBlock) return;
        const prodPrice = parseFloat(this.spBlock.dataset.productPrice);
        let variantId = '', variantPrice = '';

        if (prodPrice >= 20000) {
          variantId = this.spBlock.dataset.tier4Variant;
          variantPrice = this.spBlock.dataset.tier4Price;
        } else if (prodPrice >= 15000) {
          variantId = this.spBlock.dataset.tier3Variant;
          variantPrice = this.spBlock.dataset.tier3Price;
        } else if (prodPrice >= 7000) {
          variantId = this.spBlock.dataset.tier2Variant;
          variantPrice = this.spBlock.dataset.tier2Price;
        } else {
          variantId = this.spBlock.dataset.tier1Variant;
          variantPrice = this.spBlock.dataset.tier1Price;
        }

        if (this.priceDisplay) this.priceDisplay.textContent = '₹' + variantPrice;
        if (this.spInput) this.spInput.value = variantId;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);

        // Screen Protection Payload Transformation
        if (this.spIsAddedInput && this.spIsAddedInput.value === 'true' && this.spInput && this.spInput.value) {
          const mainId = formData.get('id');
          const mainQty = formData.get('quantity') || 1;
          const spId = this.spInput.value;
          const productId = this.form.dataset.productId;

          formData = new FormData();
          formData.append('items[0][id]', mainId);
          formData.append('items[0][quantity]', mainQty);
          formData.append('items[1][id]', spId);
          formData.append('items[1][quantity]', 1);
          formData.append('items[1][properties][_parent_product_id]', productId);
          formData.append('items[1][properties][_sp_plan]', 'true');
          
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((s) => s.id));
            formData.append('sections_url', window.location.pathname);
          }
        } else if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
